import { Pagination as ReactAdminPagination, PaginationProps } from 'react-admin'

export const Pagination = (props: PaginationProps): JSX.Element => (
  <ReactAdminPagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
)
